<template>
  <v-container class="live-body" fluid>
    <!-- <v-row justify="center">
      <v-col cols="12" md="8" class="text-center">
					<v-chip color="red" dark class="live-label">Live</v-chip>
        	<p class="date">{{ currentDate }}</p>
					<div class="video-wrapper">
						<iframe 
							src="https://player.twitch.tv/?channel=rizallivestreaming&parent=rizal-live-streaming.pages.dev" 
							frameborder="0"
							allowfullscreen
							allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share; fullscreen">
						</iframe>
					</div>
				<h3 class="event-title">Master ng Gradas</h3>
      </v-col>
    </v-row> -->
    <div class="d-flex justify-center">
      <v-chip
        color="red"
        dark
        class="highlights-label px-4 py-2 text-uppercase font-weight-bold"
      >
        Morong Arena
      </v-chip>
    </div>
    <div class="d-flex justify-center">
     <v-btn 
      text 
      :to="'/highlights'" 
      class="big-button"
    >
     <!-- WATCH OUR HIGHLIGHTS INSTEAD -->
    </v-btn>
   </div>
   <v-row justify="center" align="center" class="live-body">
     <v-col cols="12" md="10" class="d-flex justify-center">
      <iframe 
        src="https://drive.google.com/file/d/1LX9B0tjUrPAMSJ2NNmYF1QaH5VFJ_jgU/preview" 
        frameborder="0" 
        allowfullscreen
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share; fullscreen"
        class="video-frame"
      ></iframe>
     </v-col>
   </v-row>
    <h3 class="event-title d-flex justify-center">Strictly no online betting</h3>
    <v-row>
			<v-col class="text-center">
				<ChatBox/>
			</v-col>
		</v-row> 
  </v-container>
</template>

<script>
import ChatBox from '@/components/ChatBox';
export default {
  name: "Live",
	components: {
		ChatBox,
	},
  data() {
    return {
      currentDate: new Date().toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      })
    };
  }
};
</script>

<style scoped>
.video-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.live-label {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 8px;
}

.date {
  font-size: 16px;
  color: white;
  margin-bottom: 10px;
}

.live-body {
	background-color: rgba(0, 0, 0, 0.5);
	/* color:white; */
}

.event-title {
	color:white;
}

.watch-highlight {
  margin-top: 10px;
}

.big-button {
  color:rgb(255, 46, 46);
  font-size: 24px; /* Adjust size as needed */
  font-weight: bold;
  text-transform: uppercase;
  padding: 16px 32px; /* Increase padding for a bigger button */
}

.video-frame {
  width: 100%;
  max-width: 900px; /* Adjust as needed */
  height: 500px; /* Adjust as needed */
  display: block;
}
</style>
